module.exports = __webpack_public_path__ + "static/media/ic_why_hs4.c517eef0.svg";